import {Directive, HostListener, Input, Self} from '@angular/core';
import {isEmpty, isString} from 'lodash';
import {NgControl} from '@angular/forms';


@Directive({
    selector: '[inputPatternFormatter]'
})

export class InputPatternFormatter {

    pattern = /^[a-zA-Z0-9\s(\-)+',.\/:]*$/;

    constructor(@Self() private ngControl: NgControl) {}

    @Input('inputPatternFormatter')
    set newPattern(val) {
        if (isString(val) && !isEmpty(val)) {
            this.pattern = new RegExp(val);
        }
    }

    @HostListener('paste', ['$event'])
    onPaste() {
        let actualValue = this.ngControl.value;
        let newValue = '';
        for (let i = 0; i < actualValue.length; i++) {
            if (this.pattern.test(actualValue.charAt(i))) {
                newValue = newValue.concat(actualValue.charAt(i));
            }
        }
        this.ngControl.control.setValue(newValue);
    }

    @HostListener('keyup', ['$event'])
    onChanges() {
        let value = this.ngControl.value;
        let newValue = '';

        if (!value || value.length === 0 || this.pattern.test(value)) {
            return;
        }

        for (let i = 0; i < value.length; i++) {
            if (this.pattern.test(value.charAt(i))) {
                newValue = newValue.concat(value.charAt(i));
            }
        }

        this.ngControl.control.setValue(newValue);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/input-pattern.formatter.ts